/*
 * Get-user.ts
 * Description: Includes the declaration
 * of the function for getting user data
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';


/**
 * Getting user data
 *
 * @return {Object} Promise - response with user data
 * @param {Number} id - id of the user
 */
export function getUser(id: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'users/' + id,
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve({
                ...response.data.data.attributes,
                ...response.data.data.relationships,
            });
        }).catch(() => {
            reject();
        });
    });
}
